import Image from 'next/image'
import { CSSProperties } from 'react'
import { Pythago, PythagoLC } from './index.css'
interface IProps {
	style?: CSSProperties
}
export function PythagoImage({ style }: IProps) {
	return (
		<Pythago style={style}>
			<div className='bg__pythago'>
				<Image
					src={`${process.env.IMAGE_BASE_URL}/numerology/pythago-bg.png`}
					alt='about numerology'
					width={220}
					height={220}
				/>
				<div className='pythago'>
					<Image
						src={`${process.env.IMAGE_BASE_URL}/numerology/pythago.png`}
						alt='about numerology'
						width={366}
						height={324}
					/>
				</div>
			</div>
		</Pythago>
	)
}
